module.exports = "![INSERT_ALT_TEXT_HERE](https://via.placeholder.com/500x300){.img-center}\n"